import {API_SERVERLESS, getFetch} from '~commonApi';

export function apiLabelUsedIn(labelId, excel) {
    return getFetch(`${API_SERVERLESS}/backOffice/v2/used/label/${labelId}/3${excel ? '?excel=true' : ''}`, true);
}
